import { IPriceAdditionDataModel, NO_VALUE_DISPLAY } from "@ryde/shared";

import { CsvTransformerControlsMapType, ICsvColumnTransformer } from "./models";

export const addressAccessor = ({
  value,
  formAttributes,
}: ICsvColumnTransformer): string => {
  const valueTranslated = formAttributes?.isCoordinate
    ? value?.fullAddress
    : value;

  return valueTranslated ?? NO_VALUE_DISPLAY;
};

export const priceRatePricingAccessor = ({
  value,
}: ICsvColumnTransformer): string => {
  const valueTyped = value as IPriceAdditionDataModel | undefined;
  const printedValue = valueTyped?.defaultPrice ?? "0";

  return String(printedValue);
};

export const operationTransformerFnMap: CsvTransformerControlsMapType = {
  address: addressAccessor,
  price_rate_pricing: priceRatePricingAccessor,
};
